import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';

const GoogleOAuthButton = ({ onSuccess, onError }) => {
  const login = useGoogleLogin({
    onSuccess: async (response) => {
      try {
        // Get user info from Google using the access token
        console.log('Google OAuth response:', response);
        const userInfoResponse = await fetch(`https://www.googleapis.com/oauth2/v2/userinfo?access_token=${response.access_token}`);
        
        if (!userInfoResponse.ok) {
          throw new Error(`Failed to get user info: ${userInfoResponse.status}`);
        }
        
        const userInfo = await userInfoResponse.json();
        console.log('User info from Google:', userInfo);
        
        // Send the user info to our backend (Google OAuth endpoint - no whitelist)
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5002';
        const res = await fetch(`${backendUrl}/auth/google-oauth`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: userInfo.email
          }),
        });
        
        console.log('Backend response status:', res.status);
        console.log('Backend response headers:', res.headers);
        
        let data;
        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          data = await res.json();
        } else {
          const text = await res.text();
          console.error('Non-JSON response:', text);
          throw new Error('Server returned non-JSON response');
        }
        
        console.log('Backend response data:', data);
        
        if (res.ok) {
          onSuccess(data);
        } else {
          onError(new Error(data.error || 'Authentication failed'));
        }
      } catch (error) {
        console.error('Google auth error:', error);
        onError(error);
      }
    },
    onError: (error) => {
      console.error('Google login failed:', error);
      onError(error);
    },
    scope: 'email profile'
  });

  const handleGoogleLogin = () => {
    login();
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <button
        onClick={handleGoogleLogin}
        style={{
          padding: '12px 24px',
          fontSize: '16px',
          fontWeight: '500',
          backgroundColor: '#4285f4',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
        }}
      >
        <svg width="18" height="18" viewBox="0 0 18 18">
          <path fill="#EA4335" d="M17.64,9.20454545 C17.64,8.56636364 17.5827273,7.95272727 17.4763636,7.36363636 L9,7.36363636 L9,10.845 L13.8436364,10.845 C13.635,11.97 13.0009091,12.9231818 12.0477273,13.5613636 L12.0477273,15.8195455 L14.9563636,15.8195455 C16.6581818,14.2527273 17.64,11.9454545 17.64,9.20454545 L17.64,9.20454545 Z"/>
          <path fill="#34A853" d="M9,18 C11.43,18 13.4672727,17.1940909 14.9563636,15.8195455 L12.0477273,13.5613636 C11.2418182,14.1013636 10.2109091,14.4204545 9,14.4204545 C6.65590909,14.4204545 4.67181818,12.8372727 3.96409091,10.71 L0.957272727,10.71 L0.957272727,13.0418182 C2.43818182,15.9831818 5.48181818,18 9,18 L9,18 Z"/>
          <path fill="#FBBC05" d="M3.96409091,10.71 C3.78409091,10.17 3.68181818,9.59318182 3.68181818,9 C3.68181818,8.40681818 3.78409091,7.83 3.96409091,7.29 L3.96409091,4.95818182 L0.957272727,4.95818182 C0.347727273,6.17318182 0,7.54772727 0,9 C0,10.4522727 0.347727273,11.8268182 0.957272727,13.0418182 L3.96409091,10.71 L3.96409091,10.71 Z"/>
          <path fill="#4285F4" d="M9,3.57954545 C10.3213636,3.57954545 11.5077273,4.03363636 12.4404545,4.92545455 L15.0218182,2.34409091 C13.4631818,0.891818182 11.4259091,0 9,0 C5.48181818,0 2.43818182,2.01681818 0.957272727,4.95818182 L3.96409091,7.29 C4.67181818,5.16272727 6.65590909,3.57954545 9,3.57954545 L9,3.57954545 Z"/>
        </svg>
        Sign in with Google
      </button>
    </div>
  );
};

export default GoogleOAuthButton;